interface AuthFlowLayoutProps {
  headerContent?: React.ReactNode;
  headerText?: string;
  subheaderText?: string;
  isLoading?: boolean;
  loader?: React.ReactNode;
  footer?: React.ReactNode;
  formBreak?: React.ReactNode;
  children?: React.ReactNode;
}

const AuthFlowLayout: React.FC<AuthFlowLayoutProps> = ({
  headerContent,
  headerText,
  subheaderText,
  isLoading,
  footer,
  children,
  loader,
}) => {
  return (
    <div className="flex flex-col min-h-screen flex-1 lg:px-10 py-4 sm:px-6 sm:py-8">
      {/* Main Container */}
      <div className="flex flex-col flex-grow max-w-3xl mx-auto px-4 items-center">
        {/* Header Section */}
        <div className="flex flex-col items-start justify-start w-full mb-4">
          {headerContent}
          <header className="w-full">
            <h1 className="text-5xl font-bold text-black mb-4">{headerText}</h1>
            {subheaderText && (
              <p className="text-lg text-secondary-gray">{subheaderText}</p>
            )}
          </header>
        </div>
        {/* Form and Button Content Area */}
        <div className="flex-grow flex items-start justify-center w-full">
          <div className="w-full">
            {isLoading && loader}
            {children && <div className="w-full">{children}</div>}
            {footer && <div className="mt-6">{footer}</div>}
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          {loader}
        </div>
      )}
    </div>
  );
};

export default AuthFlowLayout;
